module.exports = __webpack_public_path__ + "static/img/GL-6-A智能安全帽使用说明书-1.0dd7c95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/GL-6-A智能安全帽使用说明书-1.jpg
// module id = RQRS
// module chunks = 0